import { render } from "./index.vue?vue&type=template&id=3aea6912&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=3aea6912&lang=stylus&scoped=true"

import exportComponent from "/mnt/jenkins/workspace/taoziprod-platform-webh5-remoteinquiry-master-web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3aea6912"]])

export default __exports__